module.exports = __webpack_public_path__ + "static/media/A29827F0-F3BD-4C73-9C1A-28BCA4CEA8F3_Small.05a67abd.jpg";